import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { useState } from 'react';
import { Checkbox, FormElement } from 'components/Form';
import { Header } from 'components/Text';
import { useTranslation } from 'react-i18next';
import Box from "@material-ui/core/esm/Box";
import FormControl from "@material-ui/core/esm/FormControl";
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import Radio from "@material-ui/core/esm/Radio";
import RadioGroup from "@material-ui/core/esm/RadioGroup";
import TextField from "@material-ui/core/esm/TextField";
import { Controller, useFormContext } from 'react-hook-form';
import { DEFAULT_LANGUAGE } from 'constants/language';
import { emailRegex } from 'constants/regex';
import useGetValidationStrings from 'hooks/language/useGetValidationString';
export let EmailDestination;
(function (EmailDestination) {
  EmailDestination["SAME_AS_CUSTOMER_EMAIL"] = "same_as_customer_email";
  EmailDestination["SPECIFIC_BILLING_EMAIL"] = "specific_billing_email";
})(EmailDestination || (EmailDestination = {}));
export default function CreateCustomerBillingEmail() {
  const {
    t
  } = useTranslation();
  const {
    register,
    errors,
    control,
    watch
  } = useFormContext();
  const countryCode = watch('billingAddress.countryCode');
  const receiveInvoicesByEmail = watch('receiveInvoicesByEmail');
  const {
    emailFormat
  } = useGetValidationStrings();
  const [emailDestination, setEmailDestination] = useState(EmailDestination.SAME_AS_CUSTOMER_EMAIL);
  const handleRadioGroupChange = event => {
    setEmailDestination(event.target.value);
  };
  useEffect(() => {
    if (countryCode) {
      control.setValue('receiveInvoicesByEmail', countryCode !== DEFAULT_LANGUAGE);
    }
  }, [countryCode]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "receiveInvoicesByEmail",
    defaultValue: false,
    render: ({
      onChange,
      name,
      ref,
      ...field
    }) => /*#__PURE__*/React.createElement(Checkbox, _extends({}, field, {
      name: name,
      setChecked: isChecked => {
        onChange(isChecked);
      },
      checked: receiveInvoicesByEmail,
      label: t('email.email_invoice_distribution'),
      infoText: t('email.invoice_distribution_email_help_text')
    }))
  }), receiveInvoicesByEmail && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    component: "h4"
  }, t('email.billing_email')), /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": "email destination",
    name: "emailDestination",
    value: emailDestination,
    onChange: handleRadioGroupChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: EmailDestination.SAME_AS_CUSTOMER_EMAIL,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t('email.radio_same_as_customer_email')
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: EmailDestination.SPECIFIC_BILLING_EMAIL,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t('email.radio_specific_billing_email')
  })))), emailDestination === EmailDestination.SPECIFIC_BILLING_EMAIL && /*#__PURE__*/React.createElement(FormElement, {
    title: t('email.billing_email')
  }, /*#__PURE__*/React.createElement(TextField, {
    inputRef: register && register({
      required: true,
      pattern: {
        value: emailRegex,
        message: emailFormat
      }
    }),
    required: true,
    name: "billingEmail",
    variant: "outlined",
    placeholder: 'Email',
    error: !!errors?.billingEmail,
    helperText: errors?.billingEmail?.message
  }))));
}